export const MODAL_WIDTH = 760;
